export function isBold(data: string) {
  return data.includes('!!!')
}

export function stripMarkers(data: string) {
  return data.replace(/!!!/g, '')
}
